import { render } from "./OverlayPanel.vue?vue&type=template&id=30b48578"
import script from "./OverlayPanel.vue?vue&type=script&lang=js"
export * from "./OverlayPanel.vue?vue&type=script&lang=js"

import "./OverlayPanel.vue?vue&type=style&index=0&id=30b48578&lang=css"
script.render = render

export default script